var ModalSizes;
(function (ModalSizes) {
    ModalSizes["LARGE"] = "lg";
    ModalSizes["MEDIUM"] = "md";
    ModalSizes["MEDIUM2"] = "md-2";
    ModalSizes["SMALL"] = "sm";
    ModalSizes["CUSTOM"] = "custom";
})(ModalSizes || (ModalSizes = {}));

export { ModalSizes };
//# sourceMappingURL=types.js.map
